import { IActionContext } from '../helpers/ActionContext';
import { SchedulingErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { FlowContentType } from '../models/ContentTypes';
import { IErrorItem } from '../models/MultipleItemResult';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { RunFlowTasks } from '../resources/RunFlowTasks';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ContentUrl } from './ContentUrl';

export class DeleteRunFlowTasksAction {

  public static $inject = [
      '$translate',
      'ActionHelpers',
      'ConfirmActionDialog',
      'ContentUrl',
      'RunFlowTasks'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ActionHelpers: ActionHelpers,
    private ConfirmActionDialog: ConfirmActionDialog,
    private ContentUrl: ContentUrl,
    private RunFlowTasks: RunFlowTasks
  ) { }

  public executeWithContext(runFlowTaskInfos: Set<RunFlowTaskInfo>, context: IActionContext): ng.IPromise<IResult> {

    let description: string;
    if (runFlowTaskInfos.size() === 1) {
      const task = runFlowTaskInfos.first();
      description = this.$translate.instant('confirmDeleteRunFlowTask', { FLOW_NAME: L10n.elideIfLong(task.flow.name) });
    } else {
      description = this.$translate.instant('confirmDeleteRunFlowTasks', {
        ITEM_COUNT: runFlowTaskInfos.size()
      }, L10n.Interpolations.Count);
    }

    return this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant('deleteMessage'),
      bodyText: description,
      actionName: this.$translate.instant('confirmDeleteButton', { ITEM_COUNT: runFlowTaskInfos.size() }, L10n.Interpolations.Count),
      isDeleteAction: true,

      action: (dialogInstance: IConfirmActionDialogInstance) => {
        return this.RunFlowTasks.del(runFlowTaskInfos.keys())
          .then(this.ActionHelpers.notifyStandardError(
            runFlowTaskInfos,
            {
              successId: 'deleteRunFlowTasksSuccess',
              errorId: 'deleteRunFlowTasksError'
            },
            (errorItem: IErrorItem<RunFlowTaskInfo>) => {
              const namedItem: INamedItemInfo = errorItem.item.flow;
              return {
                itemName: namedItem.name,
                itemUrl: this.urlFor(errorItem),
                errorMessage: this.errorMessageFor(errorItem)
              };
            }
          ));
      }
    }).result;
  }

  private urlFor(errorItem: IErrorItem<RunFlowTaskInfo>): string {
    return this.ContentUrl.forItem(errorItem.item.flow, FlowContentType);
  }

  private errorMessageFor(errorItem: IErrorItem<RunFlowTaskInfo>) {
    switch (errorItem.error.code) {
      case SchedulingErrorCode.SchedulingTaskNotFound:
        return this.$translate.instant('errorRunFlowTaskNotFound', {
          FLOW_NAME: L10n.elideIfLong(errorItem.item.flow.name),
          SCHEDULE_NAME: L10n.elideIfLong(errorItem.item.schedule.name)
        });
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('DeleteRunFlowTasksAction', DeleteRunFlowTasksAction);
